import { StyledModal } from '@app/components/modal/Modal';
import type { ChannelPartner } from '@app/services/api.types';
import type { ModalProps } from 'antd';
import { PartnerForm } from './PartnerForm';
import useChannelPartnerActions from '@app/hooks/channelPartners/useChannelPartnerActions';

export type PartnerAddModalProps = ModalProps & {
    title?: string;
    data?: ChannelPartner;
};

export const PartnerAddModal = ({
    title = 'New Channel Partner',
    data,
    onOk,
    ...props
}: PartnerAddModalProps) => {
    const { addChannelPartner } = useChannelPartnerActions();

    // Reset the component if closed
    if (!props.open) {
        return null;
    }

    return (
        <StyledModal title={title} mask={{ closable: false }} width={680} footer={null} {...props}>
            <PartnerForm
                id="channel-partner-add"
                data={data}
                isEdit={false}
                onCancel={props.onCancel}
                loading={addChannelPartner.isPending}
                onSubmit={(values) => {
                    const formData = {
                        ...values,
                    };
                    addChannelPartner.mutate(formData, {
                        onSuccess: () => {
                            if (onOk) {
                                onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                            }
                        },
                    });
                }}
            />
        </StyledModal>
    );
};
